'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fas';
var iconName = 'file-certificate';
var width = 576;
var height = 512;
var aliases = ["file-award"];
var unicode = 'f5f3';
var svgPathData = 'M128 64c0-35.3 28.7-64 64-64L341.5 0c17 0 33.3 6.7 45.3 18.7L493.3 125.3c12 12 18.7 28.3 18.7 45.3L512 448c0 35.3-28.7 64-64 64l-192 0 0-71.2c29.8-31.5 48-74 48-120.8 0-97.2-78.8-176-176-176l0 0 0-80zm208-5.5l0 93.5c0 13.3 10.7 24 24 24L453.5 176 336 58.5zM256 320c0 40.4-18.7 76.5-48 99.9L208 525c0 10.5-8.5 19-19 19-3.3 0-6.5-.9-9.4-2.5L128 512 76.4 541.5c-2.9 1.6-6.1 2.5-9.4 2.5-10.5 0-19-8.5-19-19l0-105.1C18.7 396.5 0 360.4 0 320 0 249.3 57.3 192 128 192s128 57.3 128 128zM128 368a48 48 0 1 0 0-96 48 48 0 1 0 0 96z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faFileCertificate = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;